import { PatientTypeConstants } from "../types/PatientTypeConstants";
let initialState = {
  all: [],
  patientDetailsById: {},
  searchResult: [],
  appointmentList : [],
  registeredSuccessfully : false,
  updatedSuccessfully : false,
};
export function patient(state = initialState, action) {
  switch (action.type) {
    case PatientTypeConstants.GET_ALL_PATIENT_SUCCESS: {
      state.all = action.data;
      return state;
    }
    case PatientTypeConstants.GET_PATIENT_BY_ID_REQUEST: {
      state.patientDetailsById = {};
      return state;
    }
    case PatientTypeConstants.GET_PATIENT_BY_ID_SUCCESS: {
      state.patientDetailsById = action.data;
      state.updatedSuccessfully=false;
      state.registeredSuccessfully=false;
      return state;
    }
    case PatientTypeConstants.REGISTER_PATIENT_SUCCESS: {
      if(action.user){
        state.patientDetailsById = action.user;
      }
      state.registeredSuccessfully=true;
      return state;
    }
    case PatientTypeConstants.UPDATE_PATIENT_SUCCESS: {
      if(action.user){
        state.patientDetailsById = action.user;
      }
      state.updatedSuccessfully=true;
      return state;
    }
    case PatientTypeConstants.SEARCH_PATIENT_SUCCESS: {
      state.searchResult = action.data;
      return state;
    }
    case PatientTypeConstants.SEARCH_PATIENT_BY_SPECIALIZATION_SUCCESS: {
      state.searchResult = action.data;
      return state;
    }
    case PatientTypeConstants.DOCTOR_APPOINTMENT_SUCCESS: {
      state.appointmentList = action.data;
      return state;
    }
    case PatientTypeConstants.UPDATE_PATIENT_REGISTRATION_FLAG: {
      state.registeredSuccessfully = action.data;
      state.updatedSuccessfully = action.data;
      return state;
    }
    case PatientTypeConstants.ADD_NEW_PATIENT: {
      state.patientDetailsById= {};
      state.registeredSuccessfully = false;
      state.updatedSuccessfully = false;
      return state;
    }
    case PatientTypeConstants.PATIENT_CLEAR_ALL: {
      state.all = [];
      state.patientDetailsById= {};
      state.searchResult= [];
      state.appointmentList = [];
      state.registeredSuccessfully = false;
      state.updatedSuccessfully = false;
      return state;
    }
    default:
      return state;
  }
}
